export enum  PlanType {
  None = 0,
  Semester = 1,
  Weekly = 2,
  Daily = 3,
}
